import { DirSport, useTypeSportsLazyQuery, useTypeSportsQuery } from '../../api';
import { Grid, Tooltip } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import React, { FC, useCallback, useState } from 'react';
import { getSettingsUserFilter, getSettingsUserFilterFormValue } from '../../store/selectors/settings';
import { useDispatch, useSelector } from 'react-redux';

import { AppStore } from '../../store/reducers';
import { BtnNew } from '../../components/BtnNew';
import { DataTable } from '../../components/DataTable/NewTable';
import { DictionaryWrapper } from '../../components/DictionaryWrapper';
import { MUIDataTableColumn } from 'mui-datatables';
import { MainTemplate } from '../../components/layouts';
import { SET_USER_SETTINGS_FILTER } from '../../store/constants';
import { TypeSportsFilter } from '../../components/Filters';
import _ from 'lodash';
import { usePermission } from '../../hooks/usePermission';

const Page: FC<{}> = () => {
  const dispatch = useDispatch();
  const filter: any = useSelector((state: AppStore) => getSettingsUserFilter(state, 'typesport'), _.isEqual);
  const formValue: any = useSelector(
    (state: AppStore) => getSettingsUserFilterFormValue(state, 'typesport'),
    _.isEqual,
  );
  const [first, setFirst] = useState(0);
  const { push } = useHistory();
  const access = usePermission('directory', 'type_sports');

  const setFilter = useCallback(
    (filter, form) => {
      dispatch({
        type: SET_USER_SETTINGS_FILTER,
        payload: {
          name: 'typesport',
          filter: filter,
          form,
        },
      });
    },
    [dispatch],
  );

  const columns: MUIDataTableColumn[] = [
    {
      name: 'id',
      label: 'Название',
      options: {
        viewColumns: false,
        filter: false,
        sort: false,
        customBodyRender: (value: Pick<DirSport, 'id'>, meta: any) => {
          return (
            <React.Fragment>
              <Tooltip title="Перейти в карточку" placement="top-start">
                <Link
                  style={{
                    fontWeight: 500,
                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                  to={`/type_sports/${value}`}
                  target={'_blank'}
                >
                  {meta.rowData[1]}
                </Link>
              </Tooltip>
            </React.Fragment>
          );
        },
      },
    },
    {
      name: 'fullName',
      label: 'Название',
      options: {
        display: false,
        sort: false,
      },
    },
    {
      name: 'evsk',
      label: 'Номер ЕВСК',
      options: {
        display: true,
        sort: false,
      },
    },
    {
      name: 'registryNumber',
      label: 'Идентификатор вида спорта',
      options: {
        display: true,
        viewColumns: false,
      },
    },
  ];

  return (
    <MainTemplate pageName="Виды спорта" url="" title="Виды спорта">
      <TypeSportsFilter
        onSubmit={(filters: any, form: any) => setFilter({ ...filters }, form)}
        value={formValue}
        defaultFilter={filter}
        first={first}
      />
      <DictionaryWrapper>
        <DataTable
          tableName="typesport"
          title={
            <React.Fragment>
              <Grid container spacing={2} alignItems={'center'}>
                <Grid item>
                  <h2>Виды спорта</h2>
                </Grid>
                {access.includes(2) && <Grid item>{<BtnNew onClick={() => push('/type_sports/new')} />}</Grid>}
              </Grid>
            </React.Fragment>
          }
          columns={columns}
          lazyQuery={useTypeSportsLazyQuery}
          filter={filter}
        />
      </DictionaryWrapper>
    </MainTemplate>
  );
};

export default Page;
